export default {
  usedZpos: false,
  zposConfigurated: false,
  zposIntegratorCollection: {},
};
